
    <div class="flex  justify-center h-full items-center">
        <div class="w-full flex flex-col p-5">
            <h2 class="font-bold">  رمز عبور انتخاب کنید</h2>
            <p class="w-full my-3 text-gray-500 text-sm">
                برای حساب کاربری خود رمز عبور انتخاب کنید، تا مجددا نیازی به کد تایید نداشته باشید. 
            </p>
            <div class="relative gap-2 my-3">
                <label for="small-test-input">انتخاب رمز عبور جدید </label>
                <div class="relative">
        
                    <input ihoInput size="md" class="w-full" id="small-test-input"
                    [(ngModel)]="passUser"
                    (input)="validatePass()"
                    class="{{errValidPass ? '!border-red-300': 'border-2' }}"
                        type="{{showPass ? 'text' : 'password'}}">
                    <button (click)="showPass = !showPass" matRipple
                        class="input-icon h-8 w-8 flex justify-center items-center rounded-full overflow-hidden">
                        <i class="{{showPass ? 'ico-Show' : 'ico-Hide'}} text-muted text-lg"></i>
                    </button>
        
                </div>
                <!-- <p *ngIf="errValidPass" class="text-red-300 text- text-xs mt-1">رمز عبور شامل  6  کارکتر  باشد.</p> -->
                 <p *ngIf="passUser.length < 6 && inputTouched" class="text-red-300 text-xs mt-2">رمز عبور باید حداقل شامل 6 کاراکتر باشد</p>
                 <p *ngIf="errValidPass" class="text-red-300 text-xs mt-2">رمز عبور باید حداقل شامل یک حرف ، یک عدد و یک کاراکتر خاص (@ # $ % &) باشد</p>
            </div>
    
    
    
            <button mat-raised-button color="primary" 
            class="!font-bold !text-base !h-11"
            [disabled]="passUser.length < 6  || errValidPass || showLoading" (click)="setPassword()">
                <div class="typing-animation" *ngIf="showLoading">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            <span *ngIf="!showLoading">    تایید رمز عبور</span>
            </button>
           
        </div>
    </div>

